// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"b5e4477a","239":"e39fb35b","248":"741a98af","278":"5e74a53c","382":"08bc8f2a","397":"a92e7d88","455":"1b991356","820":"ee23a823","833":"b7f3d6cb","842":"350e2583","970":"92962f13","977":"459ae33c"}[chunkId] + ".chunk.js";
};